<template>
  	<div class="home">
		  <ApplicationDashboard v-if="!$auth.loading && applications_open === 1 && $auth.isAuthenticated && ( $auth.user.roles.includes('admin'))" @changeGoverningBody="governing_body_id = $event"></ApplicationDashboard>
		  <Applications v-if="!$auth.loading && $auth.isAuthenticated && ( $auth.user.roles.includes('officer') || $auth.user.roles.includes('director'))" :governing-body-id="governing_body_id" @changeGoverningBody="governing_body_id = $event" v-bind:round-id="round_id" @changeRound="round_id = $event"></Applications>
	</div>
</template>

<script>

import Applications from '@/components/Applications';
import ApplicationDashboard from '@/components/Applications/ApplicationDashboard';

export default {
  name: 'Home',
	
	data: function () {
    	return {
		      people: [],
			  loading : false,
			  search: "",
				API_NAME: process.env.VUE_APP_API_NAME,
				governing_body_id: null,
			applications_open:1,
			round_id:process.env.VUE_APP_CURRENT_ROUND_ID,
		}
	},
	components: {
		Applications,
		ApplicationDashboard
	},
	created() {
		
	},
	methods: {
		// Log the user in
		login() {
			this.$auth.loginWithRedirect();
		},
		/*async getPeopleData() {
			const accessToken = await this.$auth.getTokenSilently()
			
			PeopleService.getPeople(accessToken, this.search)
			.then(
				(people => {
				this.$set(this, "people", people);
				}).bind(this)
			);
		},
		async getAllPeople() {
			const accessToken = await this.$auth.getTokenSilently()
			
			PeopleService.getAllPeople(accessToken)
			.then(
				(people => {
				this.$set(this, "people", people);
				}).bind(this)
			);
		}*/
	}
}
</script>
